"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../../index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _sortableitem_styles = _interopRequireDefault(require("./sortableitem_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// styles

/* ========== ~~~~~~~~~~ EXPORT : SORTABLE : ITEM ~~~~~~~~~~ ========== */


var _default = (0, _reactJss.default)(_sortableitem_styles.default)(function (props) {
  var item = props.item,
      selected = props.selected,
      disabled = props.disabled,
      handleSelect = props.handleSelect;
  return _react.default.createElement("span", {
    className: "sortableitem ".concat(props.classes.sortableitem)
  }, _react.default.createElement("div", {
    className: "drag-icon"
  }, _react.default.createElement(_index.Illustration, {
    name: 'dragdrop',
    text: 'Insticator'
  })), _react.default.createElement("div", {
    className: "single-item-list"
  }, _react.default.createElement(_index.SelectableList, {
    type: 'checkbox',
    items: item,
    selected: selected,
    disabled: disabled,
    handleChange: handleSelect
  })));
});

exports.default = _default;